import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";

export type CustomDialogActionsVariant = "step1" | "step2";

type Props = {
  onCancel?: () => void;
  textCancel?: string;
  cancelDisabled?: boolean;
  onConfirm?: () => void;
  textConfirm?: string;
  confirmDisabled?: boolean;
  onBack?: () => void;
  textBack?: string;
  backDisabled?: boolean;
  onOpen?: () => void;
  textOpen?: string;
  openDisabled?: boolean;
  variant: CustomDialogActionsVariant;
};

export default function CustomDialogActions({
  onCancel,
  textCancel,
  cancelDisabled,
  onConfirm,
  textConfirm,
  confirmDisabled,
  onBack,
  textBack,
  backDisabled,
  onOpen,
  textOpen,
  openDisabled,
  variant,
}: Props): ReactNode {
  const { t } = useTranslation();

  switch (variant) {
    case "step1":
      return (
        <DialogActions onClick={(e) => e.stopPropagation()}>
          {onConfirm && (
            <Button
              sx={{ width: "125px" }}
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                onConfirm();
              }}
              disabled={confirmDisabled}
            >
              {textConfirm || t("button.save")}
            </Button>
          )}
          {onCancel && (
            <Button
              sx={{ width: "125px" }}
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                onCancel();
              }}
              disabled={cancelDisabled}
            >
              {textCancel || t("button.cancel")}
            </Button>
          )}
        </DialogActions>
      );
    case "step2":
      return (
        <DialogActions onClick={(e) => e.stopPropagation()}>
          {onBack && (
            <Button
              sx={{ width: "125px" }}
              variant="outlined"
              color="success"
              onClick={(e) => {
                e.stopPropagation();
                onBack();
              }}
              disabled={backDisabled}
            >
              {textBack || t("load_configuration_dialog.back")}
            </Button>
          )}
          <div style={{ flex: 1 }} />
          {onOpen && (
            <Button
              sx={{ width: "125px", mr: 2 }}
              variant="outlined"
              color="success"
              onClick={(e) => {
                e.stopPropagation();
                onOpen();
              }}
              disabled={openDisabled}
            >
              {textOpen || t("load_configuration_dialog.open")}
            </Button>
          )}
          {onCancel && (
            <Button
              sx={{ width: "125px" }}
              variant="outlined"
              color="success"
              onClick={(e) => {
                e.stopPropagation();
                onCancel();
              }}
              disabled={cancelDisabled}
            >
              {textCancel || t("load_configuration_dialog.cancel")}
            </Button>
          )}
        </DialogActions>
      );
  }
}
